
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/landing/about",
      function () {
        return require("private-next-pages/landing/about.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/landing/about"])
      });
    }
  